import { createContext, type Context } from 'react';

export const WindowLocationContext: Context<string | null> = createContext<string | null>(null);
